import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ClientQuestionnaire from "./pages/ClientQuestionnaire";
import PartnerQuestionnaire from "./pages/PartnerQuestionnaire";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App font-manrope">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/become-a-client" element={<ClientQuestionnaire />} />
          <Route path="/become-a-partner" element={<PartnerQuestionnaire />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
